/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_RequiredInputs */

const en_admin_questionnaire_editor_required = /** @type {(inputs: Admin_Questionnaire_Editor_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This question is required`)
};

const nl_admin_questionnaire_editor_required = /** @type {(inputs: Admin_Questionnaire_Editor_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze vraag is verplicht`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_RequiredInputs) => LocalizedString} */
const de_admin_questionnaire_editor_required = en_admin_questionnaire_editor_required;

/** @type {(inputs: Admin_Questionnaire_Editor_RequiredInputs) => LocalizedString} */
const es_admin_questionnaire_editor_required = en_admin_questionnaire_editor_required;

/** @type {(inputs: Admin_Questionnaire_Editor_RequiredInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_required = en_admin_questionnaire_editor_required;

/** @type {(inputs: Admin_Questionnaire_Editor_RequiredInputs) => LocalizedString} */
const it_admin_questionnaire_editor_required = en_admin_questionnaire_editor_required;

/** @type {(inputs: Admin_Questionnaire_Editor_RequiredInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_required = en_admin_questionnaire_editor_required;

/** @type {(inputs: Admin_Questionnaire_Editor_RequiredInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_required = en_admin_questionnaire_editor_required;

/** @type {(inputs: Admin_Questionnaire_Editor_RequiredInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_required = en_admin_questionnaire_editor_required;

/** @type {(inputs: Admin_Questionnaire_Editor_RequiredInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_required = en_admin_questionnaire_editor_required;

/**
* | output |
* | --- |
* | "This question is required" |
*
* @param {Admin_Questionnaire_Editor_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_required = /** @type {((inputs?: Admin_Questionnaire_Editor_RequiredInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_RequiredInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_required(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_required(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_required(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_required(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_required(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_required(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_required(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_required(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_required(inputs)
	return ro_admin_questionnaire_editor_required(inputs)
});
export { admin_questionnaire_editor_required as "admin.questionnaire_editor.required" }